import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=cf3cf8a8&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"
import style0 from "./authorization.vue?vue&type=style&index=0&id=cf3cf8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3cf8a8",
  null
  
)

export default component.exports